module.exports = __webpack_public_path__ + "img/flexlimit.bc2416c.png";